import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Stockreports*/
export const registerStockreport = async (stockreportData) => {
  try {
    const response = await api.post("/bnf/reports", stockreportData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "stockreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchStockreportsFromAPI = async (page = 1, perPage = 10, search = "", columnFilters = {}, signal) => {
  try {
    const params = { page, per_page: perPage };
    if (search) params.search = search;
    
    // Add column-specific filters
    if (columnFilters.vendor_name) params.vendor_name = columnFilters.vendor_name;
    if (columnFilters.part_number) params.part_number = columnFilters.part_number;
    if (columnFilters.sebango) params.sebango = columnFilters.sebango;
    if (columnFilters.part_name) params.part_name = columnFilters.part_name;
    
    const response = await api.get("/bnf/reports", {
      params: params,
      signal,
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "stockreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteStockreportsFromAPI = async (stockreportId) => {
  try {
    const response = await api.delete(`/bnf/reports/${stockreportId}`, {
      params: { stockreport_id: stockreportId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "stockreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchStockreportsById = async (stockreportId) => {
  try {    
    const response = await api.get(`/bnf/reports/${stockreportId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data stockreport", "stockreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateStockreport = async (id, stockreportData) => {
  try {
    const response = await api.put(`/bnf/reports/${id}`, stockreportData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "stockreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};




export const downloadStockFileFromAPI = async (fileType, search) => {
  try {
    const response = await api.post(`/bnf/download/stock-report/${fileType}/stock-report`, search);

    //const response = await api.post(`/inventories/download/${fileType}/${vendorCode}/${formattedForecastMonth}/${commodity}`);

    if (response.data?.data?.filePath) {
      const fileUrl = response.data.data.filePath;

      // Open the file URL in a new tab for user download
      window.open(fileUrl, "_blank");
    } else {
      throw new Error("File URL not found in response.");
    }
  } catch (error) {
    const fallback = generateErrorMessage("download forecast file", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const downloadStockSummaryPDFFromAPI = async (search) => {
  try {
    const response = await api.post(`/bnf/stock-summary`, search);

    if (response.data?.data?.filePath) {
      const fileUrl = response.data.data.filePath;
      // Open the file URL in a new tab for user download
      window.open(fileUrl, "_blank");
    } else {
      throw new Error("File URL not found in response.");
    }
  } catch (error) {
    const fallback = generateErrorMessage("download stock summary PDF", "stock summary");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const downloadStockSummaryExcelFromAPI = async (search) => {
  try {
    const response = await api.post(`/bnf/stock-summary/excel`, search);

    if (response.data?.data?.filePath) {
      const fileUrl = response.data.data.filePath;
      // Open the file URL in a new tab for user download
      window.open(fileUrl, "_blank");
    } else {
      throw new Error("File URL not found in response.");
    }
  } catch (error) {
    const fallback = generateErrorMessage("download stock summary Excel", "stock summary");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};